function getCookie(name) {
  let cookieValue = null;

  if (document.cookie && document.cookie !== "") {
    const cookies = document.cookie.split(";");
    for (let i = 0; i < cookies.length; i++) {
      const cookie = cookies[i].trim();
      // Does this cookie string begin with the name we want?
      if (cookie.substring(0, name.length + 1) === name + "=") {
        cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
        break;
      }
    }
  }
  return cookieValue;
}

/**
 * Extract tenant slug from current hostname.
 * Matches Django's get_subdomain_from_request logic.
 */
export function getTenantSlug() {
  if (typeof window === "undefined" || !window.location) {
    return 'smsp'; // Default fallback
  }

  const hostname = window.location.hostname;
  const parts = hostname.split('.');

  if (parts.length >= 3) {
    // Check for {tenant}.local format first (e.g., testorg.local.strongmindstrongperformance.com)
    if (parts.length >= 4 && parts[1] === 'local') {
      const tenant = parts[0];
      // Special case: localhost should be treated as its own tenant
      if (tenant === 'localhost') {
        return 'localhost';
      }
      return tenant;
    }

    // Check for {tenant}.stage format (e.g., testorg.stage.strongmindstrongperformance.com)
    if (parts.length >= 4 && parts[1] === 'stage') {
      const tenant = parts[0];
      return tenant;
    }

    const subdomain = parts[0];
    // Special case: localhost should be treated as its own tenant
    if (subdomain === 'localhost') {
      return 'localhost';
    }

    // Fallback for www, webapp, api, localapi, stage (but not localhost)
    if (['www', 'webapp', 'api', 'localapi', 'stage'].includes(subdomain)) {
      return 'smsp';
    }

    // Backwards compatibility: handle local{tenant} format (e.g., localtestorg)
    if (subdomain.startsWith('local')) {
      return subdomain.substring(5); // Remove 'local' prefix
    }

    return subdomain;
  }

  return 'smsp'; // Default fallback
}

/**
 * Get tenant-specific CSRF cookie name.
 * Matches Django's get_tenant_csrf_cookie_name logic.
 * 
 * Note: tenantSlug is already cleaned by getTenantSlug() (removes 'local' prefix).
 */
function getTenantCSRFCookieName() {
  const tenantSlug = getTenantSlug();

  if (!tenantSlug || tenantSlug === 'smsp') {
    return 'csrftoken';
  }

  // Use tenant slug directly since it's already cleaned
  return `csrftoken_${tenantSlug}`;
}

export function getCSRFToken() {
  // Try tenant-specific cookie name first
  const tenantCookieName = getTenantCSRFCookieName();
  const tenantToken = getCookie(tenantCookieName);

  if (tenantToken) {
    return tenantToken;
  }

  // Fallback to default cookie name (for backwards compatibility or default tenant)
  const defaultCookieName = process.env.REACT_APP_CSRF_COOKIE_NAME || 'csrftoken';
  return getCookie(defaultCookieName);
}
